// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"29748292","369":"e251ffd1","667":"c3fcf84a","918":"ea930369","985":"ef9449b4"}[chunkId] + ".chunk.js";
};